import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";

import Section from "../components/Section";

import CallToAction from "../components/CallToAction";
import Carousel from "../components/Carousel";
import Grid from "../components/Grid";
import PageHero from "../components/Hero/PageHero";
import Layout from "../components/Layout";
import Scroller from "../components/Scroller";
import SEO from "../components/SEO";
import Ticker from "../components/Ticker";

import SecondaryButton from "../components/Button/SecondaryButton";


const ServicesPage = () => {
  const data = useStaticQuery(graphql`
    query {
      services: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "service"
            }
          }
        }
        sort: {
          fields: [frontmatter___order]
          order: ASC
        }
      ) {
        edges {
          node {
            frontmatter {
              title
              serviceImage {
                childImageSharp {
                  gatsbyImageData(
                    width: 700
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              order
            }
            fields {
              slug
            }
          }
        }
      }

      portfolio: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "portfolio"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              title
              homeCard {
                childImageSharp {
                  gatsbyImageData(
                    width: 1200
                    quality: 80
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <SEO title="Services" />
      
      <PageHero
        pageTitle="Services"
        pageDescription="We have had the pleasure of working with small and large organizations in all industries to help redefine their digital marketing efforts."
        Component={
          <Scroller
            layout="simple"
            nodes={ data.services.edges }
          />
        }
      />

      <Section
        sectionTitle="Ready To Start Working On Your Next Project?"
        textAlignment="center"
        containerized
        Component={
          <CallToAction
            ButtonComponent={
              <SecondaryButton
                linkLocation="/contact"
                linkText="Start A Project"
              />
            }
          />
        }
      />

      <Section
        sectionTitle="Our Partners"
        sectionDescription="We have had the pleasure of working with small and large organizations in all industries to help redefine their digital marketing efforts."
        isComponentFullLength
        Component={
          <Ticker
            template="portfolio"
            itemWidth={ 10 }
          />
        }
      />

      <Section
        sectionTitle="Our Work"
        sectionDescription="We have had the pleasure of working with small and large organizations in all industries to help redefine their digital marketing efforts."
        isComponentFullLength
        Component={
          <Carousel
            layout="portfolio"
            nodes={ data.portfolio.edges }
            service="home"
            linkLocation="/portfolio"
            linkText="Explore More"
            options={
              {
                loop: true,
              }
            }
          />
        }
      />

      <Section
        Component={
          <Ticker
            template="marketing-partner"
            itemWidth={ 16 }
          />
        }
      />
    </Layout>
  )
}


export default ServicesPage;
